import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  title: "Convolution between two signals",
  description:
    "This animation presents the convolution of a signal (in blue) with a rectangular window (in red). The shift parameter τ can be modified with the slider so as to visualise the integrand. The convoluted function is equal to the surface of the purple zone.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0303a/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
